// const productImageCarousel = require('./productImageCarousel');
const addToCartValidation = require('core/product/addToCartValidation');
const isMobile = () => window.innerWidth < 768;
const Swiper =require('swiper8/swiper-bundle');
let initialMFC = null;

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {boolean} isColorSelection - Color selection action
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, isColorSelection, $productContainer ) {
  if (selectedValueUrl) {
    $.spinner().start();
    $('body').trigger('product:beforeAttributeSelect', { url: selectedValueUrl, container: $productContainer });

    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      success: function (data) {
        handleVariantResponse(data, $productContainer);
        if (isColorSelection) {
            updateUrl(data);
        }
        //updateOptions(data.product.optionsHtml, $productContainer);
        //updateQuantities(data.product.quantities, $productContainer);
        $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer });
        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    });
  }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity for Shop the look products
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
 function attributeSelectStl(selectedValueUrl, $productContainer) {
  if (selectedValueUrl) {
    $.spinner().start();
    $('body').trigger('product:beforeAttributeSelect', { url: selectedValueUrl, container: $productContainer });

    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      success: function (data) {
        let cartActions = $productContainer.find('.add-to-cart-actions');
        let wishlistActions = $productContainer.find('.js_add-to-wish-list');

        // change the id of the variation for each size
        if (cartActions && data && data.product && data.product.id) {
          cartActions.attr('data-pid', data.product.id);
        }

        if (wishlistActions && data && data.product && data.product.id) {
          wishlistActions.attr('data-pid', data.product.id);
        }

        // Switch add to cart and notify me based on availability
        const notifyAndAddToCart = $productContainer.find('.add-to-cart-switch');

        if (notifyAndAddToCart) {
          if (notifyAndAddToCart.hasClass('show-notify-me') && data.product.available) {
            notifyAndAddToCart.removeClass('show-notify-me');
          } else if (!notifyAndAddToCart.hasClass('show-notify-me') && !data.product.available) {
            notifyAndAddToCart.addClass('show-notify-me');
          }
        }

        // Update wishlist icon
        const $addTowishListIcon = $productContainer.find('.js_add-to-wish-list');

        if ($addTowishListIcon.length > 0 && data.product && data.product.id) {
          $addTowishListIcon.toggleClass('active', data.product.inWishList);
          $addTowishListIcon.attr('data-pid', data.product.id);
        }

        $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer });
        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    });
  }
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
  let availabilityValue = '';
  const availabilityMessages = response.product.availability.additionalMessages;
  let messages= $('.js-additional-messages');
  availabilityMessages.forEach(function (message) {
    availabilityValue += `<div class="additional-msg mm-form-message -info mb-0.5">
                            <p class="m-0">${message}</p>
                          </div>`
  });
  $(messages).each(function () {
    $(this).html(availabilityValue);
  });

  availabilityValue = '';

  $($productContainer).trigger('product:updateAvailability', {
    product: response.product,
    $productContainer: $productContainer,
    message: availabilityValue,
    resources: response.resources,
  });

  // update notifyme
}

/**
 * Updates the recommendation carousel in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after the
 *                            render of new recommendations
 */
 function updateStlRecommendations(response) {
  if (response && response.queryString && response.product && response.product.stlProductsRecommendations) {
    var updateRecommendationUrl = $('.stl-update-recommendation').data('action');

    if (updateRecommendationUrl) {
      updateRecommendationUrl = updateRecommendationUrl + '?' +  response.queryString;

      $.ajax({
        url: updateRecommendationUrl,
        method: 'GET',
        success: function (data) {
          if (data) {
            // repopulate the carousel
            $('.stl-update-recommendation').html(data)

            productRecommendationsCarousel();
          }
        }
      });
    }
  }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
  // Update variation attributes
  if (response.product && response.product.variationAttributes) {
    updateAttrs(response.product.variationAttributes, $productContainer, response.resources);

    // Update radio buttons for colors (inside and outside the sheet)
    if($('.mm-colors-detail-sheet').length > 0) {
        //MM
        updateColorSwatches(response.product.variationAttributes.find(function(attr) { return attr.attributeId === 'color'; }), $productContainer, $('.mm-colors-detail-sheet'));
    } else {
        //MM6
        updateColorSwatches(response.product.variationAttributes.find(function(attr) { return attr.attributeId === 'color'; }), $productContainer);
    }


    // Update radio buttons for sizes in the sheet
    var $activeSheet = $('.mm-sheet[id^="size-selector-"]');
    updateSizeSwatches(response.product.variationAttributes.find(function(attr) { return attr.attributeId === 'size'; }), $activeSheet);

    updateSelectedSize(response.product.variationAttributes.find(function(attr) { return attr.attributeId === 'size'; }), $productContainer);
  }

  // Update product name and number
  updateProductDetails(response.product.defaultVariant ? response.product.defaultVariant : response.product, $productContainer);

  // Update size warning

  if (response.sizeMsg){
    var warningMsg = `<div class="mm-form-message -info-grey mb-0.5">
                            ${response.sizeMsg}
                          </div>`;
    $productContainer.find('.product-size-message-warning').html(warningMsg);

    var warningMsg = `<div class="mm-form-message -info-grey pb-0">
                            ${response.sizeMsg}
                          </div>`;
    $productContainer.find('.product-size-message-mobile-section').html(warningMsg);
    $('.size-switch.mm-switch__toggle').addClass('no-margin');
  }
  else {
    $productContainer.find('.product-size-message-warning').html('');
    $('.size-switch.mm-switch__toggle').removeClass('no-margin');
  }

  // Update pricing (PDP + boutique availability / shipping estimate sheets).
  // Fill the wrappers instead of replacing them, so they are still found on the next variation change.
  let $priceSelector = $('.prices', $productContainer).length ? $('.prices', $productContainer) : $('.prices');
  $priceSelector = $priceSelector.add('.js-pdp-sheet-price');
  if (response.product && response.product.defaultVariant && response.product.defaultVariant.price && response.product.defaultVariant.price.html) {
    $priceSelector.html(response.product.defaultVariant.price.html);
  } else if (response.product && response.product.price && response.product.price.html) {
    $priceSelector.html(response.product.price.html);
  }

  // Update images only if VG changes
  if (initialMFC !== response.product.modelFabricColor) {
    updateImages(response.product);
    initialMFC = response.product.modelFabricColor;
  }

  // Update availability
  updateAvailability(response, $productContainer);

  // Update Shop the Look Recommendations
  updateStlRecommendations(response);

  // manage bopis
  let bopisBtn = $('button.bopis-btn');
  bopisBtn.attr('data-pid', response.product.id);

  $('#product-show .store-item .item-error-message-container').text('');

  // update preorder
  updatePreorderDetails(response.product.defaultVariant ? response.product.defaultVariant : response.product, $productContainer);

  // Enable "Add to Cart" button if all required attributes have been selected
  let addToCartBtn = $('.add-to-cart-actions');
  const notifyAndAddToCart = $('.add-to-cart-switch');
  addToCartBtn.trigger('product:updateAddToCart', {
    product: response.product,
    $productContainer: $productContainer,
  });

  notifyAndAddToCart.toggleClass('show-notify-me', !(response.product.available));

  const isReadyToOrder = response.product.readyToOrder && response.product.available;
  $('.add-to-cart').toggleClass('disabled', !isReadyToOrder);
  $('.js-notify-me-button').toggleClass('disabled', isReadyToOrder);

  if($('.pdp-apple-pay-button-fake') ){
    $('.apple-pay-pdp-button').attr('sku', response.product.id);
    $('.pdp-apple-pay-button-fake').toggleClass('d-none', (response.product.available));
    $('.pdp-apple-pay-button').toggleClass('d-none', !(response.product.available));
  }


  // Update wishlist icon
  const $addTowishListIcon = $productContainer.find('.js_add-to-wish-list');

  if ($addTowishListIcon.length > 0) {
    $addTowishListIcon.toggleClass('active', response.product.inWishList);
    $addTowishListIcon.attr('data-pid', response.product.id);
  }
  // productImageCarousel.reInitCarousels();

  $('.js-dynamic-delivery-date').html('');
  if(response.dddEnabled && response.product.isVariant && !response.product.isPreOrder && response.product.isOrderable) {
    $('.js-dynamic-delivery-date').attr('data-pid', response.product.id);
    $('.js-dynamic-delivery-date').attr('data-runservice', 'true');

    $(document).trigger('ddd:reinit');
  }

  $('.js-add-to-cart-error').addClass('d-none').html('');

  //Rollback MCR-3838
  //updateUrl(response);

}

/**
 * Updates the selected size in the Product Detail Page size selector button
 * @param {*} sizeAttr
 */

function updateSelectedSize(sizeAttr, $productContainer){
  const sizeSelectorBtn = $productContainer.find('.pdp-sheet-cta.size-selector-button');
  const brand = sizeSelectorBtn.data('brand');
  let sizeValText = '';
  sizeAttr.values.forEach(function (sizeVal) {
      if (sizeVal.selected) {

          let country = sizeSelectorBtn.attr('data-country');
          var otherCountrySize = ' [' + country + ' ' + sizeVal.displayValue + ']'
          var iconBell = `<span class="icon icon--mm-bell"></span>`;

          if (brand === 'mm6') {
              otherCountrySize = ' (' + country + ' ' + sizeVal.displayValue + ')';
              iconBell = `<span class="icon icon--mm6-bell"></span>`
          }

          if (sizeSelectorBtn.attr('data-size-switcher-enabled') === 'true') {
              sizeValText = 'IT ' + sizeVal.value + otherCountrySize;
                if (!sizeVal.selectable) {
                  sizeValText = sizeValText + iconBell;
                }
          } else {
            sizeValText = sizeVal.displayValue;
            if (!sizeVal.selectable) {
              sizeValText = sizeValText + iconBell;
            }
          }

          if (brand === 'mm') {
              sizeSelectorBtn.find('.inner-text').html(sizeValText);
          } else {
              sizeSelectorBtn.find('.mm6-btn__left .mm6-btn__line').html(sizeValText);
              sizeSelectorBtn.find('.mm6-btn__right .mm6-btn__line').html(sizeSelectorBtn.data('changetxt'));
          }

          sizeSelectorBtn.find('.inner-text').html(sizeValText);

          // Sync active size to size guide select
          document.dispatchEvent(new CustomEvent('pdp:sizeSelected', {
            detail: {
              size: sizeVal.value
            }
          }));
      }
  });
}

/**
 * Updates the color swatches in the Product Detail Page
 *
 * @param {Object} colorAttr - Color attribute
 */
function updateColorSwatches(colorAttr, $productContainer, $sheetContainer) {
  if (colorAttr) {
    colorAttr.values.forEach(function (colorVal) {
      // Radio buttons in PDP
      const $radio = $productContainer.find('input[type="radio"][name="variation-element"]').filter(function() {
        return $(this).val() === colorVal.id || $(this).val() === colorVal.value;
      });
      if ($radio.length) {
        $radio.prop('checked', colorVal.selected);
        $radio.toggleClass('selected-color', colorVal.selected);
        $radio.siblings('.mm-color-swatch__image').toggleClass('selected-color', colorVal.selected);

        if (colorVal.selected) {
          // update text label of the selected color
          $('.selected-color-text .selected-color-text__label').text(colorVal.displayValue);
        }
      }

      //For MM
      if($sheetContainer){
          // Radio buttons in colors sheet
          const $sheetRadio = $sheetContainer.find('input[type="radio"][name="variation-element"]').filter(function() {
              return $(this).val() === colorVal.id || $(this).val() === colorVal.value;
          });

          if ($sheetRadio.length) {
              $sheetRadio.prop('checked', colorVal.selected);
              $sheetRadio.toggleClass('selected-color', colorVal.selected);
              $sheetRadio.siblings('.mm-color-swatch__image').toggleClass('selected-color', colorVal.selected);
          }
      }
    });
  }
}

/**
 * Updates the size swatches in the Product Detail Page size selector sheet
 *
 * @param {Object} sizeAttr - Size attribute
 * @param {jQuery} $sheetContainer - DOM container for the size sheet
 */
function updateSizeSwatches(sizeAttr, $sheetContainer) {
  if (sizeAttr && $sheetContainer.length) {
    sizeAttr.values.forEach(function (sizeVal) {
      const $radio = $sheetContainer.find('input[type="radio"][name="variation-size-element"]').filter(function() {
        return $(this).val() === sizeVal.id || $(this).val() === sizeVal.value;
      });

      if ($radio.length) {
        const sizeSelectorSheet = document.querySelector('.mm-sheet[id^="size-selector-"]');
        const brand = sizeSelectorSheet.dataset.brand;
        $radio.prop('checked', sizeVal.selected);
        $radio.toggleClass('selected-size', sizeVal.selected);

        const $label = $radio.closest('.mm-size-swatch');
        var $iconSelection = null;
        var $iconNotifyMe = $label.find('.icon--' + brand + '-bell');

        if (brand === 'mm') {
            $iconSelection = $label.find('.icon--mm-symbol-circle-fill');
        }

        if ($iconSelection) {
            if (sizeVal.selected) {
                $iconSelection.removeClass('hidden').addClass('selected');

                const sheetChooseYourSize = $sheetContainer.find('.choose-your-size')[0];
                if (sheetChooseYourSize) {
                    const opt = Array.from(sheetChooseYourSize.options).find(function (o) {
                        return o.value.toLowerCase() === sizeVal.value.toLowerCase();
                    });
                    if (opt) {
                        sheetChooseYourSize.value = opt.value;
                        sheetChooseYourSize.dispatchEvent(new Event('change', {bubbles: true}));
                    }
                }
            } else {
                $iconSelection.addClass('hidden').removeClass('selected');
            }
        }

        let sizeSelectorClosingBtn = null;
        let sizeSelectorClosingBtnTxt = null;
        if (sizeSelectorSheet) {
          sizeSelectorClosingBtn = sizeSelectorSheet.querySelector('.js-size-selector-closing-btn');
          sizeSelectorClosingBtnTxt = sizeSelectorSheet.querySelector('.js-size-selector-closing-btn-txt');
        }

        if (!sizeVal.selectable) {
          $radio.addClass('disabled');
          $label.addClass('disabled');
          $iconNotifyMe.removeClass('d-none');
        } else {
          $radio.removeClass('disabled');
          $label.removeClass('disabled');
          $iconNotifyMe.addClass('d-none');
        }

        //update size selector sheet button
        if (sizeSelectorClosingBtn) {
          const targetBtnTextEl = sizeSelectorClosingBtnTxt || sizeSelectorClosingBtn;
          if (sizeVal.selected && sizeVal.selectable) {
            if (targetBtnTextEl) {
              targetBtnTextEl.textContent = sizeSelectorClosingBtn.dataset.addToCartText;
            }
            sizeSelectorClosingBtn.setAttribute('data-action', '');
          } else if (sizeVal.selected && !sizeVal.selectable) {
            if (targetBtnTextEl) {
              targetBtnTextEl.textContent = sizeSelectorClosingBtn.dataset.notifyMeText;
            }
            sizeSelectorClosingBtn.setAttribute('data-action', 'notify-me');
          }
        }
      }
    });

    var $activeSystem = $sheetContainer.find('input[name="size-system"]:checked');
    if ($activeSystem.length) {
      $activeSystem.trigger('change');
    }
  }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 * @param {Object} attrs - Attributes
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
  let $attributeValues;
  let $attrColor = false;
  attrs.forEach((attr) => {
    $attributeValues = $productContainer.find('.select-' + attr.id);
    let $attrValue;
    $attrColor = attr.attributeId === 'color' ? true : false;
    attr.values.forEach(function (attrValue) {
      $attrValue = $attributeValues.find('[data-attr-value="' + attrValue.id + '"]');
      $attrValue.val(attrValue.url);

      if (!attrValue.selectable) {
        $attrValue.text(attrValue.displayValue + ' ' + msgs.variationUnavailable);
        $attrValue.addClass('disabled').prop('disabled', true);
      } else {
        $attrValue.text(attrValue.displayValue);
        $attrValue.removeClass('disabled').prop('disabled', false);
      }

      if (attrValue.selected) {
        $attrValue.prop('selected', true);

        if($attrColor && $('.default-attr-option').attr('data-attr-color') !== attrValue.id) {
          $('.default-attr-option').attr('data-attr-color', attrValue.id);
          var urlColor = attrValue.url.indexOf('size=') > -1 ? attrValue.url.substring(0, attrValue.url.indexOf('size=')+ 'size='.length) + attrValue.url.substring( attrValue.url.lastIndexOf('&pid='), attrValue.url.length) : attrValue.url;
          $('.default-attr-option').val(urlColor);
        }

      } else {
        $attrValue.removeAttr('selected');
      }
    });
  });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 * @param {Object} product - Product
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateProductDetails(product, $productContainer) {
  // Update product number
  $productContainer.attr('data-pid', product.modelFabricColor);
  // Update product name
  $productContainer.find('.product-name .title').text(product.productNamePDP);

  // Update product description
  $productContainer.find('.product-description .description-content').text(product.productDescriptionLong);

  // Update product name in breadcrumb
  let breadcrumbLastItem = $productContainer.find('.breadcrumb-item.last-element > a');
  if (breadcrumbLastItem) {
    breadcrumbLastItem.find('p').text(product.productNamePDP);
    breadcrumbLastItem.attr('href', product.selectedProductUrl);
  }

  // Update accordion details
  let careInstructionsParagraph = $productContainer.find('.care-instructions-review > .care-instructions-description');
  if (careInstructionsParagraph) {
    careInstructionsParagraph.text(product.careInstructions);
  }

  let editorialCompositionParagraph = $productContainer.find('.editorial-composition > .editorial-composition-description');
  if (editorialCompositionParagraph) {
    editorialCompositionParagraph.text(product.editorialComposition);
  }

  let sizeAndFitParagraph = $productContainer.find('.size-and-fit-review .size-and-fit-content');
  if (sizeAndFitParagraph) {
    sizeAndFitParagraph.html('');
    product.sizeAndFiteNotes.forEach(function (s) {
      sizeAndFitParagraph.append('<li>' + s + '</ul>');
    });
  }

  let modelImageSizeColorParagraph = $productContainer.find('.model-image-size-color');
  if (modelImageSizeColorParagraph) {
    modelImageSizeColorParagraph.text(product.modelImageSizeColor);
  }
}


function updatePreorderDetails(product, $productContainer){
  if (product.isPreOrder){
    // Show badge
    $productContainer.find('.preorder-badge-wrapper').removeClass("d-none");

    // Update date
    $productContainer.find('span.productPreorderReleaseDate').text(product.preorderReleaseDate);

    // Show info box
    $productContainer.find('.preorder-release-date').removeClass("d-none");
  }
  else {
    // Hide badge
    $productContainer.find('.preorder-badge-wrapper').addClass("d-none");

     // Hide info box
    $productContainer.find('.preorder-release-date').addClass("d-none");

  }

  $productContainer.find('.price.default-option .preorder-badge-wrapper').addClass("d-none");

}
function compileImageTemplate(template, img, index) {
  const productSlide = template.cloneNode(true);
  productSlide.dataset.index = index;
  const productImg = productSlide.querySelector('img');
  productImg.dataset.zoomImg = img.url;
  productImg.alt = img.alt;
  let srcSetString = '';
  productImg.dataset.srcset.split(',').forEach((w,i) => {
    if (w.includes('x')){
      const width = productImg.dataset.formats.split(',')[i]; //get the first numeric part
      const retina = w.match(/(\d+)x/)[1]; //get the numeric part before 'x'
      srcSetString += `${img.dis[width]} ${retina}x,`
    } else if (w.includes('w')){
      const width = w.match(/(\d+)w/)[1]; //get the numeric part before 'w'
      srcSetString += `${img.dis[width]} ${width}w,`
    }
  });

  productImg.dataset.srcset = srcSetString;
  productImg.srcset = srcSetString;

  return productSlide;
}

function updateUrl(response){
    if (response.product.mfcURL){
        window.history.pushState({path: response.product.mfcURL}, "", response.product.mfcURL);
    }
}

/**
 * Updates the product images in the Product Detail Page
 *
 * @param {Object} product - Product object
 */
function updateImages(product) {
  const productData = product.defaultVariant ? product.defaultVariant : product;
  const productImageTemplate = document.querySelector('#image-template .swiper-slide');
  const imagesWrapper = document.querySelector('.wrapper-pdp .col-images-stacked-wrapper');
  if (imagesWrapper) {
    imagesWrapper.innerHTML = '';
    const images = productData.swipeableImages.large.slice(0, 7);
    imagesWrapper.classList.toggle('has-paired-images', images.length > 4);
    images.forEach((img, index) => {
      imagesWrapper.append(compileImageTemplate(productImageTemplate, img, index));
    });

    if (window.pdpImagesSwiper) {
      window.pdpImagesSwiper.update();
      window.pdpImagesSwiper.slideTo(0, 0);
    }
  }

  // Keep PDP sheet thumbnails (boutique availability, shipping estimate) on the selected color
  const sheetThumb = productData.swipeableImages && productData.swipeableImages.large && productData.swipeableImages.large[0];
  if (sheetThumb) $('.js-pdp-sheet-thumb').attr('src', sheetThumb.url);
}

/**
 * Show validation popup
 * @param {Objecct} responseData response data
 */
function showNotificationPopup(responseData) {
  if (responseData) {
    let validationPopup;
    const findInStore = $('#findInStoreModal');

    if (responseData.sameProductError) {
      if (responseData.sameProductReason === 'addedForDelivery') {
        validationPopup = $('.js_addedForDelivery');
      } else if (responseData.sameProductReason === 'alreadyCustomized') {
        validationPopup = $('.js_alreadyCustomized');
      } else {
        validationPopup = $('.js_addedForPickup');
      }
    } else if (responseData.preorderProductError) {
      validationPopup = $('.js_addedForPreorder');
    } else if (responseData.giftcardError) {
      validationPopup = $('.js_giftcard__modal-error-cart');
    }

    if (validationPopup && validationPopup.length > 0) {
      findInStore.modal('hide');
      validationPopup.modal('show');
    }
  }
}

/**
 * Call add to cart
 *
 * @param {string} productId
 */
function submitProductToCart(productId) {
  $.spinner().start();
  var $addToCartBtn = $('.add-to-cart-actions, .add-to-cart');
  $addToCartBtn.prop('disabled', true);
  $addToCartBtn.css('pointer-events', 'none');
  const addToCartUrl = $('.add-to-cart-url').val();

  $('.js-add-to-cart-error').addClass('d-none').html('');

  if (addToCartUrl && productId) {
    const form = {
      pid: productId,
      quantity: 1,
    };

    const errorBox = $('.details-column-content .add-to-cart-error-messaging');
    $.ajax({
      url: addToCartUrl,
      method: 'POST',
      data: form,
      success: function (responseData) {
        // debugger;
        if (!responseData.error) {
          // Tealium event "Cart Addition"
          $('body').trigger('product:afterAddToCart', responseData);

          const updateCartBagdeEvt = new CustomEvent('cart:updateCartBadge', {
            detail: {
             itemsCount: responseData.cart.numItems
            }
          });
          // Update cart icon number
          document.dispatchEvent(updateCartBagdeEvt);

          const openCartEvt = new CustomEvent('cart:openCart');
          // Open cart sheet
          document.dispatchEvent(openCartEvt);

          var applePayNotificationWrapper = $('.notifications-apple-pay-button');
          if (applePayNotificationWrapper.length) {
            applePayNotificationWrapper.addClass('d-none')
          };
          // show notification on mobile
          if (isMobile()) {
            const event = new CustomEvent('notification:show', {
              detail: {
                message: responseData.message,
                icon: true,
                linkCart: false,
                linkWishlist: false,
                addToCartModal: true,
                addToCartContent: responseData.addToCartContent
              }
            });

            if (applePayNotificationWrapper.length) {
              $.ajax({
                url: applePayNotificationWrapper.data('url'),
                method: 'GET',
                success: function(result) {
                  if (result.showApplePayButton) {
                    applePayNotificationWrapper.removeClass('d-none');
                  }
                }
              });
            }

            document.body.dispatchEvent(event);
          } else {
            // Open minicart
            $('.minicart-action').trigger('click');
            $('#layer-minicart').addClass('is-open');
          }


          // close size selector sheet if it is open
          const sizeSelectorSheet = document.querySelector('.mm-sheet[id^="size-selector-"]');
          if (sizeSelectorSheet && sizeSelectorSheet.classList.contains('-opened')) {
            const closeSizeSelectorSheetEvt = new CustomEvent('MMSheet:close', {
              detail: {
                id: sizeSelectorSheet.id
              }
            })

            document.dispatchEvent(closeSizeSelectorSheetEvt);
          }

          // close pdp detail sheet if it is open
          const pdpDetailSheet = document.querySelector('.mm-sheet[id^="product-detail-"]');
          if (pdpDetailSheet && pdpDetailSheet.classList.contains('-opened')) {
            const closePdpDetailSheetEvt = new CustomEvent('MMSheet:close', {
              detail: {
                id: pdpDetailSheet.id
              }
            })

            document.dispatchEvent(closePdpDetailSheetEvt);
          }

          if (!errorBox.hasClass('d-none')) {
            errorBox.addClass('d-none');
          }

          $('.size-switch.mm-switch__toggle').removeClass('no-margin');
        } else {
          $('.js-add-to-cart-error').removeClass('d-none').html(responseData.message);
          showNotificationPopup(responseData);
          errorBox.removeClass('d-none');
          $('.details-column-content .add-to-cart-error-messaging > div').html(responseData.message);
          $('.size-switch.mm-switch__toggle').addClass('no-margin');
        }

        document.getElementById('main-overlay').style.display = 'none';
        $.spinner().stop();
        var $addToCartBtn = $('.add-to-cart-actions, .add-to-cart');
        $addToCartBtn.prop('disabled', false);
        $addToCartBtn.css('pointer-events', 'auto');
      },
      error: function () {
        document.getElementById('main-overlay').style.display = 'none';
        $.spinner().stop();
        var $addToCartBtn = $('.add-to-cart-actions, .add-to-cart');
        $addToCartBtn.prop('disabled', false);
        $addToCartBtn.css('pointer-events', 'auto');
      },
    });
  }
}

/**
 * Init Product Recommendations Carousel
 *
 */
 function productRecommendationsCarousel() {
  var numberOfSlides = $('[data-number-of-slides]').length ? $('[data-number-of-slides]')[0].dataset.numberOfSlides : 0;

  var settings = {
    slidesPerView: 1,
    observer: true,
    loop: true,
    spaceBetween: 8,
    createElements: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 5,
        watchOverflow: true,
        loop: false,
        spaceBetween: 8,
      }
    }
  };

  if (numberOfSlides >= 6) {
    settings.breakpoints = {
      640: {
        slidesPerView: 5,
        loop: true,
        spaceBetween: 8,
      }
    }
  };

  const swiper = new Swiper('.product-carousel-products-init', settings);
}

function updateCountrySelector() {
  const productDetail = document.querySelector('.product-detail');
  const pid = productDetail ? productDetail.getAttribute('data-pid') : null;
  if (pid) {
    const countrySelectorHeader = document.querySelector('.country-selector-header');
    const countrySelectorFooter = document.querySelector('.country-selector-footer');

    if (countrySelectorHeader) {
      countrySelectorHeader.setAttribute('href', countrySelectorHeader.getAttribute('href') + '?pid=' + pid);
    }

    if (countrySelectorFooter) {
      countrySelectorFooter.setAttribute('href', countrySelectorFooter.getAttribute('href') + '?pid=' + pid);
    }
  }
}

let pdpImagesSwiper;

function initPdpImagesSwiper() {
  const swiperEl = document.querySelector('.js-pdp-images-swiper');
  if (!swiperEl) return;

  // const initSwiper = () => {
  //   if (isMobile()) {
  //     if (!pdpImagesSwiper || pdpImagesSwiper.destroyed) {
  //       pdpImagesSwiper = new Swiper('.js-pdp-images-swiper', {
  //         spaceBetween: 10,
  //         observer: true,
  //         observeParents: true,
  //         pagination: {
  //           el: '.swiper-pagination',
  //           clickable: true,
  //         },
  //       });
  //       window.pdpImagesSwiper = pdpImagesSwiper;
  //     }
  //   } else {
  //     if (pdpImagesSwiper && !pdpImagesSwiper.destroyed) {
  //       pdpImagesSwiper.destroy(true, true);
  //       pdpImagesSwiper = null;
  //       window.pdpImagesSwiper = null;
  //     }
  //   }
  // };

  const initSwiper = () => {
    if (isMobile()) {
      if (!pdpImagesSwiper || pdpImagesSwiper.destroyed) {
        const EASING_NEXT = 'cubic-bezier(0, 0, 0.58, 1)';
        const DURATION_NEXT = 500;
        const EASING_PREV = 'linear';
        const DURATION_PREV = 300;

        const applyZIndices = (swiper) => {
          if (!swiper || !swiper.slides) return;
          swiper.slides.forEach((slideEl) => {
            const slide = slideEl;
            const p = typeof slide.progress === 'number' ? slide.progress : 0;
            if (p < -0.001) slide.style.zIndex = '2';      // upcoming (peek/buffer) — on top
            else if (p > 0.001) slide.style.zIndex = '0';  // past — behind active
            else slide.style.zIndex = '1';                  // active
          });
        };

        const setSlideTransition = (swiper, duration, easing) => {
          if (!swiper || !swiper.slides) return;
          swiper.slides.forEach((slideEl) => {
            const slide = slideEl;
            slide.style.transitionDuration = `${duration}ms`;
            slide.style.transitionTimingFunction = easing;
          });
        };

        pdpImagesSwiper = new Swiper('.js-pdp-images-swiper', {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: DURATION_NEXT,
          grabCursor: false,
          loop: true,
          threshold: 5,
          longSwipesRatio: 0.25,
          effect: 'creative',
          creativeEffect: {
            limitProgress: 2,
            perspective: false,
            prev: {
              translate: [0, 0, 0],
              opacity: 1,
            },
            next: {
              translate: ['calc(100% - var(--mm-pdp-carousel-sliver, 18px))', 0, 0],
              opacity: 1,
            },
          },
          a11y: { enabled: true },
          breakpoints: {
            768: { allowTouchMove: false },
            0:   { allowTouchMove: true },
          },
          pagination: {
              el: '.js-pdp-swiper-pagination',
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
            },
          on: {
            init: function () {
              applyZIndices(this);
            },
            setTranslate: function () {
              applyZIndices(this);
            },
            resize: function () {
              applyZIndices(this);
            },
            update: function () {
              applyZIndices(this);
            },
            slideNextTransitionStart: function () {
              setSlideTransition(this, DURATION_NEXT, EASING_NEXT);
            },
            slidePrevTransitionStart: function () {
              setSlideTransition(this, DURATION_PREV, EASING_PREV);
            },
            slideChangeTransitionEnd: function () {
              setSlideTransition(this, 0, '');
              const activeEl = this.slides[this.activeIndex];
              if (activeEl && activeEl.classList.contains('swiper-slide-duplicate')) {
                this.loopFix();
              }
            }
          }
        });
        window.pdpImagesSwiper = pdpImagesSwiper;
      }
    } else {
      if (pdpImagesSwiper && !pdpImagesSwiper.destroyed) {
        pdpImagesSwiper.destroy(true, true);
        pdpImagesSwiper = null;
        window.pdpImagesSwiper = null;
      }
    }
  };

  initSwiper();

  const pdpImagesMql = window.matchMedia('(max-width: 767.98px)');
  if (typeof pdpImagesMql.addEventListener === 'function') {
    pdpImagesMql.addEventListener('change', initSwiper);
  } else {
    // Safari < 14 fallback
    pdpImagesMql.addListener(initSwiper);
  }
}

function initMobileStickyFooter(brand, pdpLayoutSelector, stickyFooterSelector, hasBreadcrumb) {
    const isMobile = window.matchMedia("(max-width: 767px)");
    if (!isMobile.matches || window.brandCategory !== brand) return;

    // Elementi DOM principali
    const originalTitleBlock = document.querySelector('#product-content-title');
    const originalActionsBlock = document.querySelector('#product-content-actions');
    const pdpPageArea = document.querySelector(pdpLayoutSelector);
    const stickyFooter = document.querySelector(stickyFooterSelector);

    if (!originalTitleBlock || !originalActionsBlock || !pdpPageArea || !stickyFooter) return;

    // Helper per ottenere l'altezza del viewport visivo dinamico (Mobile Chrome/Safari)
    function getViewportHeight() {
        return window.visualViewport ? window.visualViewport.height : window.innerHeight;
    }

    // Evento Click sul titolo sticky
    const stickyTextTrigger = stickyFooter.querySelector('.footer-product-info');
    if (stickyTextTrigger) {
        stickyTextTrigger.style.cursor = 'pointer';
        stickyTextTrigger.addEventListener('click', function() {
            if (originalTitleBlock) {
                originalTitleBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
    }

    // Gestione Breadcrumb
    const nameCtaRow = stickyFooter.querySelector('.mm-mobile-sticky-footer');
    let originalBreadcrumbBlock = null;

    if (hasBreadcrumb) {
        const candidateBreadcrumb = pdpPageArea.querySelector('#product-breadcrumbs-content');

        if (candidateBreadcrumb) {
            originalBreadcrumbBlock = candidateBreadcrumb;

            // Requisito aggiornato: il breadcrumb nello sticky non e' piu' condizionato
            // all'altezza del contenuto (gallery+banner+nameCta < viewport, la vecchia
            // eleggibilita' "pagina corta") - va mostrato ogni volta che quello nativo e'
            // ancora sotto/coperto dall'area occupata dallo sticky, qualunque sia la
            // lunghezza della pagina. has-breadcrumb resta quindi sempre attivo quando
            // l'elemento nativo esiste; la visibilita' effettiva la decide solo
            // updateStickyFooterStateForBreadcrumbs() (classe breadcrumb-hidden), in base
            // alla posizione reale del breadcrumb nativo.
            stickyFooter.classList.add('has-breadcrumb');
        }
    }

    // Scrive la classe solo se il valore desiderato differisce da quello attuale,
    // per evitare mutazioni ridondanti della classList ad ogni frame di scroll.
    function setStickyClass(cls, shouldHave) {
        const has = stickyFooter.classList.contains(cls);
        if (shouldHave && !has) stickyFooter.classList.add(cls);
        else if (!shouldHave && has) stickyFooter.classList.remove(cls);
    }

    function updateStickyFooterState() {
        const viewportHeight = getViewportHeight();
        const titleRect = originalTitleBlock.getBoundingClientRect();
        const actionsRect = originalActionsBlock.getBoundingClientRect();
        const pdpPageRect = pdpPageArea.getBoundingClientRect();
        const footerHeight = stickyFooter.offsetHeight;
        // Margine di isteresi: assorbe le variazioni di footerHeight tra stati
        // (compact/expanded/breadcrumb hanno altezze diverse) senza bisogno di
        // cachare l'altezza tra chiamate.
        const THRESHOLD_MARGIN = 12;

        // Il testo prodotto+prezzo della bar si nasconde solo quando il titolo
        // nativo è pienamente visibile per conto suo, sopra l'area occupata
        // dalla bar: fuori viewport (sotto la piega, o scrollato via sopra) o
        // coperto dalla bar stessa, il testo nella bar resta visibile per non
        // lasciare l'informazione priva di un posto leggibile in pagina.
        const footerTop = viewportHeight - footerHeight;
        const nativeTitleClearOfFooter = titleRect.top >= 0 && titleRect.bottom <= footerTop;
        setStickyClass('hide-product-info', nativeTitleClearOfFooter);

        if (pdpPageRect.bottom > 0) {
            // CASO 1: Inizio pagina
            if (titleRect.top > 0 && titleRect.top < (viewportHeight - footerHeight - THRESHOLD_MARGIN)) {
                setStickyClass('is-hidden', false);
                setStickyClass('is-expanded', true);
            } else if (titleRect.top > 0 && titleRect.top > (viewportHeight - footerHeight + THRESHOLD_MARGIN)) {
                setStickyClass('is-hidden', false);
                setStickyClass('is-expanded', false);
            }

            // CASO 2: Elementi nativi visibili
            if (titleRect.top < viewportHeight && actionsRect.top < (viewportHeight - footerHeight - THRESHOLD_MARGIN)) {
                setStickyClass('is-hidden', true);
            } else {
                // CASO 3: Bottom / scroll intermedio
                if (actionsRect.bottom <= 0) {
                    setStickyClass('is-hidden', true);
                } else if (titleRect.bottom < 0 && actionsRect.top > viewportHeight + THRESHOLD_MARGIN) {
                    setStickyClass('is-hidden', false);
                    setStickyClass('is-expanded', true);
                }
            }
        }
    }

    function updateStickyFooterStateForBreadcrumbs() {
        if (!originalBreadcrumbBlock || !nameCtaRow) return;

        const viewportHeight = getViewportHeight();
        const breadcrumbRect = originalBreadcrumbBlock.getBoundingClientRect();
        const safeZoneBottom = viewportHeight - nameCtaRow.offsetHeight;

        if (breadcrumbRect.top <= 0 || breadcrumbRect.bottom <= safeZoneBottom) {
            setStickyClass('breadcrumb-hidden', true);
        } else {
            setStickyClass('breadcrumb-hidden', false);
        }
    }

    // Definizione centrale aggiornamenti (Prima dell'uso negli observer)
    function runAllUpdates() {
        updateStickyFooterState();
        updateStickyFooterStateForBreadcrumbs();
    }

    // CREAZIONE INTERSECTION OBSERVER
    const observerOptions = {
        root: null,
        threshold: [0, 0.25, 0.5, 0.75, 1.0]
    };

    const mainObserver = new IntersectionObserver(() => {
        runAllUpdates();
    }, observerOptions);

    mainObserver.observe(originalTitleBlock);
    mainObserver.observe(originalActionsBlock);
    mainObserver.observe(pdpPageArea);

    if (originalBreadcrumbBlock) {
        mainObserver.observe(originalBreadcrumbBlock);
    }

    // ASCOLTATORI EVENTI MOBILE (Scroll + Dynamic Viewport Resize)
    let isTicking = false;
    window.addEventListener('scroll', () => {
        if (!isTicking) {
            window.requestAnimationFrame(() => {
                runAllUpdates();
                isTicking = false;
            });
            isTicking = true;
        }
    }, { passive: true });

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', () => {
            window.requestAnimationFrame(runAllUpdates);
        });
    }

    // Avvio immediato al primo render
    runAllUpdates();
}

function mobileMM6StickyFooter() {
    initMobileStickyFooter('MM6', '#mm6-pdp-layout', '#mm6-mobile-sticky-footer', false);
}

function mobileMMStickyFooter() {
    initMobileStickyFooter('MM', '#mm-pdp-layout', '#mm-mobile-sticky-footer', true);
}

function closeSizeSelectorMM6() {
    document.addEventListener('MMSheet:closed', (e) => {
        const sheetElement = e.detail.element;

        if (sheetElement.id === 'size-guide-mm6-sheet' || sheetElement.id === 'product-detail-sheet') {
            if ($(sheetElement).find('[data-component="MMSizeSelect"]').hasClass('is-open')) {
                $('[data-component="MMSizeSelect"]').click();
            }
        }
    });
}

function initModules(){
  initPdpImagesSwiper();
  productRecommendationsCarousel();
  updateCountrySelector();
  checkApplepay();
  activateScrollBehavior();
  mobileMM6StickyFooter();
  mobileMMStickyFooter();
  closeSizeSelectorMM6();
}

function fastCheckout(cartType, buttonPosition) {
  var fastCheckoutUrl = $(".track-fast-checkout-url").val();
  var fastCheckoutData = cartType + '_fast_' + buttonPosition;

  if(fastCheckoutUrl) {
    $.ajax({
      url: fastCheckoutUrl,
      method: 'GET',
      dataType: 'json',
      data: { fastPayment: fastCheckoutData},
      success: function (data) {
        $('body').trigger('checkout:fastCheckoutStart', [cartType, buttonPosition]);
      }
    });
  }
}

function checkApplepay() {
  // Only surface the Apple Pay button on devices/browsers that actually support it (real Safari
  // with Apple Pay capability). On non-Safari the native <isapplepay> element renders as an empty
  // box, so bail out before hitting the server / injecting anything.
  var applePayAvailable = false;
  try {
    applePayAvailable = !!(window.ApplePaySession && typeof window.ApplePaySession.canMakePayments === 'function' && window.ApplePaySession.canMakePayments());
  } catch (e) {
    applePayAvailable = false;
  }
  if(!applePayAvailable) {
    return;
  }

  const ipayWrapperURL  = $('.ipay-wrapper') ?  $('.ipay-wrapper').data('url') : false;
  if(ipayWrapperURL) {
    $.ajax({
      url: ipayWrapperURL,
      method: 'GET',
      success: function (responseData) {
        if(responseData.applePayEnabled && responseData.ipayButton ) {
          $('.ipay-wrapper').html(responseData.ipayButton);
          $('.apple-pay-pdp-button-fake').on('click', function() {
            $('.add-to-cart-actions').trigger('click');
          });
        }
      },
      error: function () {
        console.log('Error while getting apple pay configuration');
      },
    });

  }

}

function activateScrollBehavior() {
  if (window.brandCategory === 'MM6') return;

  const addToCartWrapper = $('.col-details .add-to-cart-mobile-section');
  const addToCartWrapperPlaceholder = $('.col-details .add-to-cart-mobile-placeholder');

  $(document).scroll(function () {
    if (addToCartWrapper.length > 0) {
        if (window.isMobile()) {
            var documentHeight = addToCartWrapper[0].getBoundingClientRect().top + window.scrollY;
            var toScroll = documentHeight - window.innerHeight;
            var buttonHeight = addToCartWrapper[0].clientHeight + parseFloat(addToCartWrapper.css('margin-bottom'));
            var toScrollPosition = parseInt(toScroll + buttonHeight);

            if (window.scrollY > toScrollPosition ) {
                addToCartWrapperPlaceholder.css({'height': '0px'});
                addToCartWrapper.find('.custom-switch').removeClass('sticky-cta');
            } else {
                addToCartWrapperPlaceholder.css({'height': addToCartWrapper[0].getBoundingClientRect().height+'px'});
                addToCartWrapper.find('.custom-switch').addClass('sticky-cta');
            }
        }
        else {
            addToCartWrapper.removeClass('sticky-cta');
        }
    }
  });
}

module.exports = {
  bindEvents: function(){
    if(document.readyState !== 'loading') {
      initModules();
    } else {
      document.addEventListener("DOMContentLoaded",function(){
        initModules();
      });
    }

    this.setInitialMFC();
  },
  setInitialMFC: function() {
    if ($('.product-detail').length){
      initialMFC = $('.product-detail').attr('data-pid');
    }
  },
  // setWishListIcon rimossa: era l'unico export di questo modulo che serviva a tutte le
  // pagine, e ci arrivava solo perche' main.js includeva ./pdp ovunque. Ora vive in
  // components/wishlist.js come customerWishlistState — quel modulo e' incluso da main.js
  // su ogni pagina, questo no.
  selectAttribute: function () {
    $(document).on('change', 'select[class*="select-"]', function (e) {
      e.preventDefault();

      let isStlSelectAttribute = false;
      let isColorSelection = e.currentTarget.classList.contains('js-select-color');
      $('.size-not-selected-message').addClass('visually-hidden');

      $('.size-switch.mm-switch__toggle').removeClass('no-margin');

      // Check if it's a shop the look prd
      let shopTheLookPDP = $(this).closest('.stl-pdp');
      if (shopTheLookPDP && shopTheLookPDP.find('.add-to-cart-actions').length > 0) {
        let cartActions = shopTheLookPDP.find('.add-to-cart-actions');
        if (cartActions.attr('data-stl-add-to-cart') === 'true') {
          isStlSelectAttribute = true;
        }
      }

      // It's a shop the look prd
      if (isStlSelectAttribute) {
        let $productContainerStl = $(this).closest('.stl-pdp');
        attributeSelectStl(e.currentTarget.value, $productContainerStl);
      } else {
        let $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
          $productContainer = $(this).closest('.product-detail');
        }
        // Guard added: this listener is bound to `select[class*="select-"]` document-wide, which
        // also matches selects outside any PDP context (e.g. the wishlist landing page's
        // .select-color/.select-size, required there for addToCartValidation.js's own identical
        // wildcard). Without a real .set-item/.product-detail ancestor, attributeSelect() would
        // treat the select's plain attribute value (not a URL there) as a variation URL, fetch
        // garbage, and throw when handleVariantResponse tries to read response.product off an
        // HTML response.
        if (!$productContainer.length) {
          return;
        }
        $(this).parent().removeClass('invalid');
        attributeSelect(e.currentTarget.value, isColorSelection, $productContainer);
      }
    });
  },
  updateAddToCart: function () {
    $('.add-to-cart-actions').on('product:updateAddToCart', function (e, response) {
      const product = response.product;
      //const isMaster = product.productType === 'master';
      response.$productContainer.find('.add-to-cart').attr('data-pid', product.id);
    });
  },
  addToCart: function () {
    $('.add-to-cart-actions').on('click', function (e) {
      $('body').trigger('product:beforeAddToCart', this); // eslint-disable-line no-undef
      // Check if it's a shop the look prd
      if ($(this).attr('data-stl-add-to-cart') === 'true') {
        let $productContainerStl = $(this).closest('.stl-pdp');

        if (addToCartValidation($productContainerStl)) {
          submitProductToCart($(this).attr('data-pid'));
        }
      } else {
        let $productContainer = $('.product-detail');
        if (addToCartValidation($productContainer)) {
          submitProductToCart($(document).find('button.add-to-cart').attr('data-pid'));
        } else {
          let currentAction = $('.js-size-selector-closing-btn').attr('data-action');
          if(currentAction === 'notify-me') {
            // Notify me sheet to open
            var $activeSheet = document.querySelector('.mm-sheet[id^="notify-me-"]');
            const notifyMeSheetEvt = new CustomEvent('MMSheet:open', {
              detail: {
                id: $activeSheet.id,
              },
            });

            const sizeSelectorSheet = document.querySelector('.mm-sheet[id^="size-selector-"]');
            if (sizeSelectorSheet && sizeSelectorSheet.classList.contains('-opened')) {
              const closeSizeSelectorSheetEvt = new CustomEvent('MMSheet:close', {
                detail: {
                  id: sizeSelectorSheet.id
                }
              })
              document.dispatchEvent(closeSizeSelectorSheetEvt);
            }

            var  sizeGuideSheet = null;
            if(document.body.dataset.gcat && document.body.dataset.gcat === 'MM') {
                sizeGuideSheet = document.querySelector('.mm-sheet[id^="product-detail-"]');
            } else {
                sizeGuideSheet = document.querySelector('.mm-sheet[id^="size-guide-"]');
            }
            if (sizeGuideSheet && sizeGuideSheet.classList.contains('-opened')) {
                const closeSizeGuideSheetEvt = new CustomEvent('MMSheet:close', {
                    detail: {
                        id: sizeGuideSheet.id
                    }
                })
                document.dispatchEvent(closeSizeGuideSheetEvt);
            }

            document.dispatchEvent(notifyMeSheetEvt);
          } else {
            // Size not selected --> open size selector sheet here
            $productContainer.find('.pdp-sheet-cta.size-selector-button').trigger('click');
          }
        }
      }
    });
  },
  trackFastCheckout: function(){
    $(document).on('DOMNodeInserted', function(e) {
      if($(e.target).hasClass('paypal-checkout-sandbox')) {
        if(!document.activeElement.parentElement.parentElement.classList.contains('paypal-cart-button-minicart')){
            fastCheckout('paypal', 'pdp');
        }
      }
    });

    $('body').on('click', '.apple-pay-pdp-button', function() {
      fastCheckout('applepay', 'pdp');
    });
  },
  // scrolToFirstBreadcrumb: function() {
  //  document.getElementById("breadcrumb").scrollLeft = 0;
  // },
  colorSwatchSelect: function () {
    $(document).on('change', 'input[type="radio"][name="variation-element"]', function (e) {
      e.preventDefault();
      const $radio = $(this);
      const targetValue = $radio.val();
      const displayValue = $radio.attr('data-display-value');
      const pidValue = $radio.attr('data-variation-pid') || null;

      // Update color name text
      $('.selected-color-text .selected-color-text__label').text(displayValue);

      if(pidValue) {
          $('.pid-copy-to-clipboard .pid-value').text(pidValue);
          $('.pid-copy-to-clipboard .js-copy-pid').attr('data-pid', pidValue);
      }

      // Update selected class on radio elements
      $('input[name="variation-element"]').removeClass('selected-color');
      $('.mm-color-swatch__image').removeClass('selected-color');
      $radio.addClass('selected-color');
      $radio.siblings('.mm-color-swatch__image').addClass('selected-color');

      // Propagate the value to the hidden select dropdown
      const colorSelect = document.querySelector('.js-select-color');
      if (colorSelect) {
        const targetOption = colorSelect.querySelector(`[data-attr-value="${targetValue}"]`);
        if (targetOption) {
          colorSelect.value = targetOption.value;
          let changeEvent = new Event('change', { "bubbles": true });
          colorSelect.dispatchEvent(changeEvent);
        }
      }

      // Close colors detail sheet if it's open
      if($('.mm-colors-detail-sheet').length > 0 && $('.mm-colors-detail-sheet').hasClass('-show')){
        document.dispatchEvent(new CustomEvent('MMSheet:close', {
          detail: {
            id: 'colors-detail-sheet'
          }
        }));
      }
    });
  },
  sizeSwatchSelect: function () {
    $(document).on('click', 'input[name="variation-size-element"]', function (e) {
      const $radio = $(this);
      const targetValue = $radio.val();

      // Update selected class on radio elements inside the sheet
      $('input[name="variation-size-element"]').removeClass('selected-size');
      $radio.addClass('selected-size');

      // Update selected/hidden status of circle icons inside the swatches names
      $('input[name="variation-size-element"]').each(function () {
        const $siblingRadio = $(this);
        const $label = $siblingRadio.closest('.mm-size-swatch');
        const $icon = $label.find('.icon--mm-symbol-circle-fill');
        if ($siblingRadio.is(':checked') || $siblingRadio.hasClass('selected-size')) {
          $icon.removeClass('hidden').addClass('selected');
        } else {
          $icon.addClass('hidden').removeClass('selected');
        }
      });

      // Propagate the value to the hidden select dropdown
      let $productContainer = $radio.closest('.set-item');
      if (!$productContainer.length) {
        $productContainer = $radio.closest('.product-detail');
      }
      if (!$productContainer.length) {
        $productContainer = $('.product-detail');
      }
      const sizeSelect = $productContainer.find('.js-select-size').length ? $productContainer.find('.js-select-size')[0] : $productContainer.find('.select-size')[0];
      if (sizeSelect) {
        const targetOption = sizeSelect.querySelector(`[data-attr-value="${targetValue}"]`);
        if (targetOption) {
          sizeSelect.value = targetOption.value;
          let changeEvent = new Event('change', { "bubbles": true });
          sizeSelect.dispatchEvent(changeEvent);
        }
      }

      // Propagate the value to the hidden select dropdown inside the sheet if exists
      const $sheet = $radio.closest('.mm-sheet[id^="size-selector-"]');
      if ($sheet.length) {
        const sheetChooseYourSize = $sheet.find('.choose-your-size')[0];
        if (sheetChooseYourSize) {
          const opt = Array.from(sheetChooseYourSize.options).find(function (o) {
            return o.value.toLowerCase() === targetValue.toLowerCase();
          });
          if (opt) {
            sheetChooseYourSize.value = opt.value;
            sheetChooseYourSize.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });
  },
  closeNotifyMeSheet: function () {
    $(document).on('click', '#notify-me-modal .modal-close', function () {
      const notifyMeSheet = document.querySelector('.mm-sheet[id^="notify-me-"]');
      if (notifyMeSheet) {
        document.dispatchEvent(new CustomEvent('MMSheet:close', {
          detail: { id: notifyMeSheet.id }
        }));
      }
    });
  },
  sizeSystemSwitch: function () {
    $(document).on('change', 'input[name="size-system"]', function () {
      var selectedSystem = $(this).val();
      var $sizeContainer = $('.size-container');

      $sizeContainer.find('.mm-size-swatch').each(function () {
        var $swatch = $(this);
        var displayValue = $swatch.attr('data-display-value');
        var value = $swatch.attr('data-value');
        var $span = $swatch.find('.mm-size-swatch__value');

        if (selectedSystem === 'LABEL') {
          $span.text(value);
        } else {
          $span.text(displayValue);
        }
      });
    });
  },
  attachSizeGuideEvent: function () {
    $(document).on('sizeGuide:sizeSelected', function (e) {
      const selectedSizeValue = e.originalEvent ? e.originalEvent.detail.size : (e.detail ? e.detail.size : null);
      if (selectedSizeValue) {
        const $radio = $('input[name="variation-size-element"]').filter(function() {
          return $(this).val().toLowerCase() === selectedSizeValue.toLowerCase();
        });
        if ($radio.length) {
          if (!$radio.prop('checked')) {
            $radio.prop('checked', true);
            $radio.trigger('click');
          }
        }
      }
    });
  },
  copyToClipboard: function() {
    const copyButtons = document.querySelectorAll('.js-copy-pid');
    copyButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const pid = this.getAttribute('data-pid');
            if (pid) {
                navigator.clipboard.writeText(pid)
                    .then(() => {
                        const brand = this.getAttribute('data-brand').toLowerCase();
                        const openPopupEvt = new CustomEvent('MMPopup:open', {
                          detail: {
                            id: 'copy-pid-to-clipboard-popup-' + brand
                          }
                        });
                        document.dispatchEvent(openPopupEvt);
                    })
                    .catch(err => {
                        console.error('Error during copy PID:', err);
                    });
            } else {
                console.warn('data-pid attribute missing or empty on this button.');
            }
        });
    });
  },
  toggleSizeGuideSelectorSheet: function () {
    $(document).on('click', '.js-show-size-guide-btn', function (e) {
      e.preventDefault();
      const $btn = $(this);
      const $toggleContent = $btn.closest('.size-guide-toggle-content-wrapper').find('.size-guide-toggle-content');

      if ($toggleContent.hasClass('d-none')) {
        $toggleContent.removeClass('d-none');
          if (document.body.dataset.gcat && document.body.dataset.gcat === 'MM') {
              $btn.html($btn.attr('data-hide-text') + ' &raquo;');
          } else {
              $btn.html($btn.attr('data-hide-text'));
          }
      } else {
        $toggleContent.addClass('d-none');
          if (document.body.dataset.gcat && document.body.dataset.gcat === 'MM') {
              $btn.html($btn.attr('data-show-text') + ' &raquo;');
          } else {
              $btn.html($btn.attr('data-show-text'));
          }
      }
    });
  },
  initUnisizeUnitToggle: function () {
    $(document).on('change', '.js-unisize-unit', function () {
      const unit = $(this).val();
      const $container = $(this).closest('.unisize-dimensions');
      if (unit === 'cm') {
        $container.find('._measures-cm').removeClass('d-none');
        $container.find('._measures-in').addClass('d-none');
      } else {
        $container.find('._measures-cm').addClass('d-none');
        $container.find('._measures-in').removeClass('d-none');
      }
    });
  }
};

